import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#006f25',
    secondary: '#455A64',
    accent: '#006f25',
    error: '#9E1200',
    info: '#009f9f',
    success: '#009f00',
    warning: '#EB6D17'
  },
  dark: {
    primary: '#009f4f',
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

export default {
  dark: false,
  options: {
    customProperties: true
  },
  themes: themes
}
